export class ConfirmDialogModel<T> {
    constructor(
        public title: string, 
        public message: string,
        public object: T) { }
}